import { Component } from '@angular/core';
import { ModalController, Events } from 'ionic-angular';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ModalOcorrencias } from './modal';
import 'rxjs/add/operator/map';

@Component({
  selector: 'ocorrencias',
  templateUrl: 'ocorrencias.html'
})
export class OcorrenciasPage {

	public nome = localStorage.getItem("nomeUsuario");

	public ocorrencias:Object;

	constructor(private http: Http, public modalCtrl: ModalController, public events: Events) {
		this.events.subscribe('ocorrenciaApagada', () => {
			this.getData();
	    });
	}

	ionViewWillLoad(){
	    this.getData();
	}

	getData(){
		this.respGetData().subscribe(data => {
			this.ocorrencias = data.locais;
		});
	}

	respGetData(): Observable<any> {
    	return this.http.get("http://maisalguemdoente.com.br/web/ocorrencias/webService/getOcorrencia?id="+localStorage.getItem("idUsuario")).map((res: Response) => res.json());
  	}

  	openModal(id, nome, usuario, data, sintomas, doenca){
		let modal = this.modalCtrl.create(ModalOcorrencias, { id: id, nome: nome, usuario: usuario, data: data, sintomas: sintomas, doenca: doenca });
 		modal.present();
  	}
}


// WEBPACK FOOTER //
// ./src/pages/ocorrencias/ocorrencias.ts